import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import React from 'react';
import { usePopoverContext } from './context.js';
import { Close } from '@indeed/ifl-icons';
import { jsx } from '@emotion/react';
import { Button } from '../Button/Button.js';
import { StyledMenuOverlay } from '../Menu/MenuOverlay.js';
import { StyledTooltipPopup } from '../Tooltip/TippyTooltip.js';
import { AccessibleTrap } from '../AccessibleTrap/AccessibleTrap.js';
import '@indeed/ihl-use-id';
import 'focus-visible';
import '@indeed/ifl-css';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../Spinner/Spinner.js';
import '../IconWrapper/IconWrapper.js';
import '@tippyjs/react/headless';
import '../Tooltip/Arrow.js';
import '../Tooltip/plugins.js';
import '../../utils/warnDeprecation.js';
import '../../utils/warn.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import 'react-remove-scroll';
import '../AccessibleTrap/FocusTrap.js';
import 'react-focus-lock';
import '../../hooks/useInertA11yBackground.js';
import '../../hooks/useForceUpdate.js';

const MobilePopoverContainer = _ref => {
  let {
    sx = {},
    ...props
  } = _ref;
  const {
    getCloseButtonProps,
    titleId
  } = usePopoverContext();
  const {
    onClick
  } = getCloseButtonProps();
  return jsx(React.Fragment, null, jsx(StyledMenuOverlay, {
    sx: {
      zIndex: 0
    },
    onClick: onClick
  }), jsx(StyledTooltipPopup, _extends({
    sx: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      paddingBlockStart: 3,
      paddingBlockEnd: 3,
      paddingInlineStart: 3,
      paddingInlineEnd: 3,
      maxInlineSize: "100%",
      borderTopLeftRadius: "lg",
      borderTopRightRadius: "lg",
      boxShadow: "mobilePopover",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      variant: "text.level3",
      ...sx
    },
    "aria-labelledby": titleId
  }, props)));
};
const TooltipPopoverContainer = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    sx = {},
    ...props
  } = _ref2;
  const {
    titleId
  } = usePopoverContext();
  return jsx(StyledTooltipPopup, _extends({
    visible: true,
    ref: ref,
    sx: {
      paddingBlockStart: 5,
      paddingBlockEnd: 5,
      paddingInlineStart: 5,
      paddingInlineEnd: 5,
      position: "relative",
      color: "foreground",
      borderRadius: "md",
      boxShadow: "medium",
      minInlineSize: "200px",
      maxInlineSize: "400px",
      variant: "text.level3",
      ...sx
    },
    "aria-labelledby": titleId
  }, props));
});
const PopoverContainer = _ref3 => {
  let {
    children,
    ...props
  } = _ref3;
  const {
    isMobile,
    getCloseButtonProps
  } = usePopoverContext();
  const Container = isMobile ? MobilePopoverContainer : TooltipPopoverContainer;
  const {
    sx,
    ...otherCloseButtonProps
  } = getCloseButtonProps();
  return jsx(AccessibleTrap, {
    disableScroll: isMobile,
    initializeFocus: true,
    restoreFocus: true
  }, jsx(Container, _extends({
    "data-mobile": isMobile
  }, props), jsx(Button, _extends({
    iconOnly: true,
    sx: {
      float: "right",
      minInlineSize: "unset",
      minBlockSize: "unset",
      marginBlockStart: "-0.125em",
      marginBlockEnd: 0,
      marginInlineStart: 2,
      marginInlineEnd: 0,
      paddingInlineStart: 0,
      paddingInlineEnd: 0,
      paddingBlockStart: 0,
      paddingBlockEnd: 0,
      ...sx
    },
    variant: "tertiary",
    size: "sm",
    type: "button"
  }, otherCloseButtonProps), jsx(Close, {
    "aria-hidden": true
  })), children));
};

export { PopoverContainer };
